let megamenus = document.querySelectorAll('.item__submenu');
let main_content = document.querySelector('.content-for-layout');
let nav_links = document.querySelectorAll('.list__item:not(.list__item_no-child)');

const addActiveLink = event => {
  let parent_link = event.target.closest('.list__item').querySelector('.list__item-title');
  parent_link.classList.add('active');
}
const removeActiveLink = event => {
  let parent_link = event.target.closest('.list__item').querySelector('.list__item-title');
  parent_link.classList.remove('active');
  //remove body overlay when exit
  main_content.classList.remove('active');
}


megamenus.forEach(el => el.addEventListener('mouseover', event => {
  addActiveLink(event);
}));
megamenus.forEach(el => el.addEventListener('mouseleave', event =>{
  removeActiveLink(event);
}));
nav_links.forEach(el => el.addEventListener('mouseleave', event =>{
  removeActiveLink(event);
}));  
document.addEventListener('keydown', event => {
  main_content.classList.remove('active');
});


nav_links.forEach(el => el.addEventListener('mouseover', () =>{
  main_content.classList.add('active');
}));

// Mobile drawer
let menu_burger = document.querySelector('.header__menu-icon');
let menu_drawer = document.querySelector('.menu-drawer__container');
let header = document.getElementById('shopify-section-header');
if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

const openMenu = event => {
  menu_drawer.classList.toggle('active');
  if (menu_drawer.classList.contains('active')){
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom)}px`);
  }

  menu_burger.querySelectorAll('svg').forEach(el => el.classList.toggle('active'));
  document.body.classList.toggle('overflow-hidden');

}

menu_burger.addEventListener('click', openMenu);

// Search overlay
document.querySelector('.search__input_desktop').onblur = () =>{
  main_content.classList.remove('active');
}

document.querySelector('.search__input_desktop').onclick = () =>{
  main_content.classList.add('active');
}